import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { LitswRegistrationConfig } from '@bcf2-v1-ui-shared/service-worker/litsw-registration.types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const LITSW_REGISTRATION_CONFIG: DiToken<LitswRegistrationConfig | undefined> = new DiToken<
  LitswRegistrationConfig | undefined
>('litswRegistrationConfig', {
  factory: () => undefined
});
